import React, { useEffect, useState } from 'react';
// import hero from '../../Assert/offerpage.png'
import Card from '../../Components/Shared/Card/Card';
import { useSelector } from 'react-redux'
// import { useSearchParams } from 'react-router-dom'

const Search = () => {
    const [result, setResult] = useState([])
    const productList = useSelector((state) => state.cart.allProducts)
    const searchText = useSelector((state) => state.cart.search)

    useEffect(() => {
        const res = productList.filter(item => item.title.toLowerCase().includes(searchText.toLowerCase()))
        setResult(res)
    }, [searchText, productList])


    return (
        <div className="mt-20 pt-2">
            {/* <div className="w-4/5 mx-auto mt-16 pt-2">
                <img src={hero} className='w-full' alt="" />
            </div>
            <div className="mb-4 py-2 bg-gray-300">
                <div className="text-sm breadcrumbs">
                    <ul>
                        <li>
                            <a href='/'>Home</a>
                        </li>
                        <li>
                            <a href='/'>Documents</a>
                        </li>
                        <li>Add Document</li>
                    </ul>
                </div>
            </div> */}
            {result.length !== 0 && <div>
                <h5 className='font-semibold text-red-500 '>Search keyword: {searchText} && Found Result: {result?.length}</h5> <br />
            </div>}
            <div className='grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 '>



                {result?.map((product) => (
                    <Card key={product._id} product={product} />

                )
                )}
            </div>
            {result.length === 0 && <div className='flex justify-center items-center mt-24 text-center'>
                <h1 className=' text-4xl text-red-300 font-extrabold '>No Result Found Here</h1>
            </div>}
        </div>
    );
};

export default Search;